"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matrix = void 0;

var _matrix = require("./matrix");

var matrix = {
  matrixForQuery: _matrix.matrixForQuery
};
exports.matrix = matrix;
//# sourceMappingURL=index.js.map